import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const CASHIN_RESULT = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'CASHIN_RESULT')

// ------------------------------------
// Actions
// ------------------------------------
export function init(globalId) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: '/jollychic-service/cashin/order',
        method: 'POST',
        body: {
          globalId: globalId,
          accessToken: sessionStorage.getItem('accessToken')
        },
        requestAction: CASHIN_RESULT.INIT_REQUEST,
        successAction: CASHIN_RESULT.INIT_SUCCESS,
        success: function(result) {}
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CASHIN_RESULT.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [CASHIN_RESULT.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'cashInResult',
    reducerMap: {
      cashInResultState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
